export default "__VITE_ASSET__Bo0w58FA__"